import { Link } from "react-router-dom";

import styled from "@emotion/styled";

const FooterWrapper = styled.footer`
  background-color: ${p => p.theme.colors.white};
  padding: 26px 0;

  & svg {
    width: 139px;
    height: 24px;

    @media (min-width: ${p => p.theme.screenSizes.mdMax}) {
      width: 180px;
      height: 31px;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${p => p.theme.space[4]}px;

  @media (min-width: ${p => p.theme.screenSizes.mdMin}) {
    flex-direction: row;
    align-items: center;
    gap: ${p => p.theme.space[0]}px;
  }
`;

const StyledLink = styled(Link)`
  display: flex;
`;

const Text = styled.p`
  font-size: 16px;
  color: ${p => p.theme.colors.secondary.popular_queries};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: ${({ theme }) => theme.fontSizes.m};
  }
`;

export { FooterWrapper, Wrapper, StyledLink, Text };
